import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodes, $isRootOrShadowRoot, $createParagraphNode, COMMAND_PRIORITY_EDITOR } from 'lexical';
import { $wrapNodeInElement } from '@lexical/utils';
import { INSERT_PAGE_BREAK_COMMAND, $createPageBreakNode } from '../nodes/PageBreakNode';

export default function PageBreakPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_PAGE_BREAK_COMMAND,
      () => {
        const pageBreak = $createPageBreakNode();
        $insertNodes([pageBreak]);
        if ($isRootOrShadowRoot(pageBreak.getParentOrThrow())) {
          $wrapNodeInElement(pageBreak, $createParagraphNode).selectEnd();
        }
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
